import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { fg } from '@atlassian/jira-feature-gating';
import VirtualAgentViewStandardFlowQuery from './src/__generated__/VirtualAgentViewStandardFlowQuery$parameters';

export const viewStandardFlowEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-virtual-agent-view-standard-flow" */ './src/VirtualAgentViewStandardFlow.tsx'
			),
	),
	getPreloadProps: ({ context, tenantContext }: EntryPointRouteParams) => ({
		queries: {
			page: {
				parameters: VirtualAgentViewStandardFlowQuery,
				variables: {
					cloudId: tenantContext.cloudId,
					projectKey: context.match.params.projectKey ?? '',
					flowId: context.match.params.flowId ?? '',
					offerEscalationEnabled: fg('toggle_offer_escalation_standard_flow_feature') ?? false,
				},
			},
		},
	}),
});
